export default "__VITE_ASSET__C5kML9Jy__"